import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Careers2.css';

const Careers2 = () => {
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('http://localhost:5001/api/admin/jobs', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setJobs(response.data);
      } catch (error) {
        console.error('Error fetching jobs:', error);
      }
    };

    if (currentUser) {
      fetchJobs();
    } else {
      navigate('/login');
    }
  }, [currentUser, navigate]);

  const handleJobClick = (id) => {
    navigate(`/jobs/${id}`);
  };

  return (
    <Container className="my-5">
      <h2>Current Openings</h2>
      <Row>
        {jobs.map((job) => (
          <Col key={job._id} md={4}>
            <Card className={`job-card ${job.status}`} onClick={() => handleJobClick(job._id)}>
              <Card.Body>
                <Card.Title>{job.title}</Card.Title>
                <Card.Text><strong>Experience:</strong> {job.experience}</Card.Text>
                <Card.Text><strong>Location:</strong> {job.location}</Card.Text>
                <Card.Text><strong>Type:</strong> {job.type}</Card.Text>
                <Card.Text><strong>Work Location:</strong> {job.workLocation}</Card.Text>
                <Card.Text><strong>Experience Level:</strong> {job.experienceLevel}</Card.Text>
                <Card.Text><strong>Short Description:</strong> <div dangerouslySetInnerHTML={{ __html: job.shortDescription }} /></Card.Text>
                <Card.Text><strong>Status:</strong> {job.status}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Careers2;
